<template>
  <div v-if="announcements.length" class="announcement-stack">
    <v-row class="mx-0">
      <v-col
        v-for="announcement in announcements"
        :key="announcement.id"
        cols="12"
        :md="getMdCols(announcement.layout)"
        class="px-0 px-sm-2 py-2"
      >
        <AnnouncementCard :announcement="announcement" />
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import AnnouncementCard from "@/components/AnnouncementCard.vue";
import {
  ANNOUNCEMENT_LAYOUT_MAP,
  normalizeAnnouncementLayout,
} from "@/constants/announcements";

defineProps({
  announcements: {
    type: Array,
    default: () => [],
  },
});

const getMdCols = (layout) =>
  ANNOUNCEMENT_LAYOUT_MAP[normalizeAnnouncementLayout(layout)]?.mdCols || 12;
</script>

<style scoped>
.announcement-stack {
  margin-top: 4px;
}
</style>
